import { observer } from "mobx-react-lite";
// import { useState } from "react";
// import { useParams } from "react-router-dom";
// import { IProduct } from "~/common/models";

export const ChatPage = observer(() => {
  //   const [product, setProduct] = useState<IProduct>();

  //   let { id, chatId } = useParams();

  return <div>ChatPage</div>;
});
